import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FlatButton from 'components/consumer/FlatButton';
import useIsHoverDevice from 'hooks/useIsHoverDevice';
const FlatButtonFilters = t0 => {
  const $ = _c(33);
  const {
    customFinalButton,
    isSelectedButtonFilled: t1,
    items,
    loading: t2,
    onMouseEnter,
    onMouseLeave,
    scrollOnMobile: t3,
    selectedItem,
    setSelectedItem,
    showMarginBottom: t4,
    variant
  } = t0;
  const isSelectedButtonFilled = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const scrollOnMobile = t3 === undefined ? false : t3;
  const showMarginBottom = t4 === undefined ? true : t4;
  const isHoverDevice = useIsHoverDevice();
  if (loading) {
    let t5;
    if ($[0] !== showMarginBottom) {
      t5 = classNames("flex flex-wrap [&>*]:mr-[5px] [&>*:last-child]:mr-0", {
        "[&_>_*]:mb-1.5": showMarginBottom
      });
      $[0] = showMarginBottom;
      $[1] = t5;
    } else {
      t5 = $[1];
    }
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = [0, 1, 2, 3, 4, 5].map(_temp);
      $[2] = t6;
    } else {
      t6 = $[2];
    }
    let t7;
    if ($[3] !== t5) {
      t7 = <div className={t5}>{t6}</div>;
      $[3] = t5;
      $[4] = t7;
    } else {
      t7 = $[4];
    }
    return t7;
  }
  const t5 = variant === "PDPSelectUpholstery";
  let t6;
  if ($[5] !== scrollOnMobile || $[6] !== showMarginBottom || $[7] !== t5) {
    t6 = classNames("flex flex-wrap [&>*]:mr-[5px] [&>*:last-child]:mr-0", {
      "max-[1023px]:!flex-nowrap max-[1023px]:!whitespace-nowrap max-[1023px]:!pl-[22px] max-[1023px]:!pr-[470px]": t5,
      "[&>*]:mb-1.5": showMarginBottom,
      "max-[767px]:flex-nowrap max-[767px]:-ml-5 max-[767px]:-mr-5 max-[767px]:pl-5 max-[767px]:overflow-auto": scrollOnMobile
    });
    $[5] = scrollOnMobile;
    $[6] = showMarginBottom;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isHoverDevice || $[10] !== isSelectedButtonFilled || $[11] !== items || $[12] !== onMouseEnter || $[13] !== onMouseLeave || $[14] !== scrollOnMobile || $[15] !== selectedItem || $[16] !== setSelectedItem) {
    let t8;
    if ($[18] !== isHoverDevice || $[19] !== isSelectedButtonFilled || $[20] !== onMouseEnter || $[21] !== onMouseLeave || $[22] !== scrollOnMobile || $[23] !== selectedItem || $[24] !== setSelectedItem) {
      t8 = t9 => {
        const {
          color,
          id,
          label
        } = t9;
        return <FlatButton key={id} isSelected={typeof selectedItem === "string" ? id === selectedItem : selectedItem?.includes(id)} scrollOnMobile={scrollOnMobile} onClick={() => setSelectedItem(id)} onMouseEnter={isHoverDevice && !!onMouseEnter ? () => onMouseEnter(id) : undefined} onMouseLeave={isHoverDevice && !!onMouseLeave ? () => onMouseLeave(id) : undefined} color={color} isSelectedButtonFilled={isSelectedButtonFilled}>{label}</FlatButton>;
      };
      $[18] = isHoverDevice;
      $[19] = isSelectedButtonFilled;
      $[20] = onMouseEnter;
      $[21] = onMouseLeave;
      $[22] = scrollOnMobile;
      $[23] = selectedItem;
      $[24] = setSelectedItem;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    t7 = items.map(t8);
    $[9] = isHoverDevice;
    $[10] = isSelectedButtonFilled;
    $[11] = items;
    $[12] = onMouseEnter;
    $[13] = onMouseLeave;
    $[14] = scrollOnMobile;
    $[15] = selectedItem;
    $[16] = setSelectedItem;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[26] !== scrollOnMobile) {
    t8 = !!scrollOnMobile && <FlatButton spacer={true} scrollOnMobile={true} />;
    $[26] = scrollOnMobile;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== customFinalButton || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t9 = <div className={t6}>{t7}{customFinalButton}{t8}</div>;
    $[28] = customFinalButton;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
};
FlatButtonFilters.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  })),
  loading: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  scrollOnMobile: PropTypes.bool,
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  setSelectedItem: PropTypes.func,
  showMarginBottom: PropTypes.bool,
  variant: PropTypes.oneOf(['PDPSelectUpholstery']),
  isSelectedButtonFilled: PropTypes.bool
};
export default FlatButtonFilters;
function _temp(index) {
  return <FlatButton loading={true} key={index} />;
}